export { FuelPumpIcon } from './fuel-pump'
